import React from 'react';
import { SvgIconProps } from '@mui/material';
import FolderRoundedIcon from '@mui/icons-material/FolderRounded';
import FolderOpenRoundedIcon from '@mui/icons-material/FolderOpenRounded';
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import FavoriteRoundedIcon from '@mui/icons-material/FavoriteRounded';
import SportsEsportsRoundedIcon from '@mui/icons-material/SportsEsportsRounded';
import BoltRoundedIcon from '@mui/icons-material/BoltRounded';
import FlagRoundedIcon from '@mui/icons-material/FlagRounded';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import ScheduleRoundedIcon from '@mui/icons-material/ScheduleRounded';
import LocalFireDepartmentRoundedIcon from '@mui/icons-material/LocalFireDepartmentRounded';
import EmojiEventsRoundedIcon from '@mui/icons-material/EmojiEventsRounded';

// フォルダの見た目（色・アイコン）を一元管理する。

export const DEFAULT_FOLDER_COLOR = '#8b95a5';

export const FOLDER_COLORS: string[] = [
  '#d9ff00', // lime（テーマプライマリ）
  '#29b6f6', // blue
  '#66bb6a', // green
  '#ffa726', // orange
  '#ef5350', // red
  '#ab47bc', // purple
  '#ec407a', // pink
  '#26a69a', // teal
  '#8b95a5', // gray
];

type IconDef = { key: string; label: string; Icon: React.ComponentType<SvgIconProps> };

export const FOLDER_ICONS: IconDef[] = [
  { key: '', label: 'フォルダ', Icon: FolderRoundedIcon },
  { key: 'star', label: 'スター', Icon: StarRoundedIcon },
  { key: 'favorite', label: 'ハート', Icon: FavoriteRoundedIcon },
  { key: 'game', label: 'ゲーム', Icon: SportsEsportsRoundedIcon },
  { key: 'bolt', label: '稲妻', Icon: BoltRoundedIcon },
  { key: 'flag', label: 'フラグ', Icon: FlagRoundedIcon },
  { key: 'check', label: 'チェック', Icon: CheckCircleRoundedIcon },
  { key: 'schedule', label: '時計', Icon: ScheduleRoundedIcon },
  { key: 'fire', label: '炎', Icon: LocalFireDepartmentRoundedIcon },
  { key: 'trophy', label: 'トロフィー', Icon: EmojiEventsRoundedIcon },
];

const ICON_MAP: Record<string, React.ComponentType<SvgIconProps>> = Object.fromEntries(
  FOLDER_ICONS.map((d) => [d.key, d.Icon]),
);

// 空/未設定なら既定色を返す。
export const folderColor = (color?: string | null): string =>
  color && color.trim() ? color : DEFAULT_FOLDER_COLOR;

interface FolderGlyphProps extends SvgIconProps {
  iconKey?: string | null;
  open?: boolean; // 既定アイコン時のみ「開いたフォルダ」表現に切替
}

export const FolderGlyph: React.FC<FolderGlyphProps> = ({ iconKey, open, ...props }) => {
  const key = iconKey || '';
  if (key === '') {
    const Comp = open ? FolderOpenRoundedIcon : FolderRoundedIcon;
    return <Comp {...props} />;
  }
  const Comp = ICON_MAP[key] || FolderRoundedIcon;
  return <Comp {...props} />;
};
